import { DomainStatus } from "./types";
import { call, put, takeLatest } from "redux-saga/effects";

import {
  fetchDowntimeStart,
  fetchDowntimeSucceeded,
  fetchDowntimeFailed,
} from "./slice";

import { AxiosResponse } from "axios";
import { createRequest } from "../../utils/requestUtils";

export function* fetchDowntime() {
  try {
    const url = "/open/downtime/status/EDHCustomer";
    const { data }: AxiosResponse<DomainStatus> = yield call(createRequest, {
      method: "get",
      url,
    });

    yield put(fetchDowntimeSucceeded(data));
  } catch (error) {
    const errorMessage = error instanceof Error ? error.toString() : "error";
    yield put(fetchDowntimeFailed(errorMessage));
  }
}

function* downtimeSaga() {
  yield takeLatest(fetchDowntimeStart, fetchDowntime);
}

export default downtimeSaga;
